import EuropeLayoutStyleComponent from "../../../containers/components/europe-2024-layout-style.component";
import EuropeHeader from "../../../components/header/europe-2025-header";

type headerBanner = {
  bannerImage: string;
  headerText: string;
  topCommonMesage: string;
  mobileBanner: string;
};

const Banner = (props: headerBanner) => {
  return (
    <>
      <EuropeHeader />
      <EuropeLayoutStyleComponent />

      <EuropeBannerStyleComponent {...props} />
      <div id="header-image" className="header-image">
        <img src={props.mobileBanner} alt="Event Hero" className="mobile-image" />
        <div className="top-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: props.topCommonMesage }}></div>
      <div className="bottom-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
    </>
  );
};

export default Banner;

const EuropeBannerStyleComponent = (props: headerBanner) => {
  return (
    <>
      <style>
        {`
        .header-image{
            background-image: url( ${props.bannerImage});
            background-position: center bottom !important;
           
        }
        @media(min-width: 1025px){
            .mobile-image{
                display: none;
            }
        }
        @media(max-width: 1024px){
            .header-image{
                background-image: none
            }  
        }
        @media(max-width: 1024px){
            .top-text{
                display: none;
            } 
        }
        @media(min-width: 1025px){
            .bottom-text{
                display: none;
            }
        }
        .announcement {
          text-align: center;
          font-weight: bold;
          color: #FFF !important;
          background: #0E8ACB !important;
          padding: 13px 0;
          font-size: 110%;
        }
    `}
      </style>
    </>
  );
};
